<template>
  <div class="qweb-column-scrollbar" v-show="show" :class="{'qweb-scrolling': scrolling}" @wheel="scrollByWheel" :style="{width: canUseWidth + 'px', left: leftHeaderWidth + 'px'}">
    <button class="q-icon-button left" @click.native="onLeftClick" />
    <div class="qweb-scroll-area" @click="onScrollAreaClick">
      <button ref="scroll" class="q-icon-button qweb-scroll" :style="{ width: scrollWidth + 'px', left: scrollLeft + 'px' }" @mouseup.native="onMouseUp($event)" @mousedown.native="onMouseDown($event)" />
    </div>
    <button class="q-icon-button right" @click.native="onRightClick" />
  </div>
</template>
<script>
const maxLeft = 0
const leftAndRightWidth = (12 * 2)
export default {
  name: 'column-scrollbar',
  props: {
    table: {
      type: HTMLDivElement
    },
    data: Array
  },
  data () {
    return {
      show: false,
      canUseWidth: 0,
      moveRange: 0,
      overWidth: 0,
      moveStep: 0,
      left: 0,
      leftPercentage: 0,
      scrollWidth: 0,
      scrolling: false,
      scrollLastY: 0,
      delayScrollToElement: {},
      leftHeaderWidth: 0
    }
  },
  mounted: function () {
    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy: function () {
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    handleMouseMove: function (event) {
      if (this.scrolling) {
        const mouseMoveRange = event.clientX - this.scrollLastX
        this.scrollLastX = event.clientX
        this.scroll(-mouseMoveRange)
      }
    },
    handleMouseUp: function (event) {
      this.scrolling = false
    },
    onMouseDown: function (event) {
      this.scrolling = true
      this.scrollLastX = event.clientX
    },
    onMouseUp: function (event) {
      this.scrolling = false
    },
    onLeftClick: function () {
      this.scroll(this.mouseMoveRange)
    },
    onRightClick: function () {
      this.scroll(-this.mouseMoveRange)
    },
    onScrollAreaClick: function (event) {
      if (event.target.className === 'qweb-icon-button scroll') {
        return
      }
      const scrollLeft = parseInt(this.$refs.scroll.$el.style.left.replace('px', ''))
      const scrollWidth = parseInt(this.$refs.scroll.$el.style.width.replace('px', ''))
      if (event.layerX < scrollLeft) {
        this.left = -event.layerX
      } else {
        this.left = -(event.layerX - scrollWidth)
      }
      this.scrollElementByLeft()
    },
    getTableHeader () {
      let children = Array.from(this.table.children)
      return children.filter((child) => {
        return (child.className === 'header')
      })[0]
    },
    calculate () {
      let header = this.getTableHeader()
      if (header.children.length === 2) {
        let leftHeader = header.children[0]
        let rightHeader = header.children[1]
        this.leftHeaderWidth = leftHeader.offsetWidth
        const contentWidth = rightHeader.offsetWidth
        this.canUseWidth = this.table.offsetWidth - leftHeader.offsetWidth
        this.overWidth = contentWidth - this.canUseWidth
        if (this.canUseWidth !== 0 && this.overWidth > 0 && this.data.length > 0) {
          this.show = true
          const scrollFreeWidth = this.canUseWidth - leftAndRightWidth
          this.scrollWidth = scrollFreeWidth * (scrollFreeWidth / contentWidth)
          this.moveRange = scrollFreeWidth - this.scrollWidth
          this.moveStep = this.overWidth / this.moveRange
          if (this.overWidth > 0) {
            if (this.delayScrollToElement && this.delayScrollToElement.offsetTop) {
              this.scrollTo(this.delayScrollToElement)
              this.delayScrollToElement = {}
            } else {
              // let scrollbar top keep on the same position
              this.left = this.moveRange * this.leftPercentage
            }
          }
        } else {
          this.left = 0
          this.show = false
        }
      }
    },
    delayScrollTo: function (element) {
      this.delayScrollToElement = element
    },
    scrollTo: function (element) {
      if (!this.show) return
      let header = this.getTableHeader()
      let rightHeader = header.children[1]
      const contentWidth = rightHeader.offsetWidth
      let newLeft = element.offsetLeft
      // check whether the newLeft exceed the content height
      if (newLeft + this.canUseWidth > contentWidth) {
        newLeft = contentWidth - this.canUseWidth
      }
      this.left = -(newLeft / this.moveStep)
      this.leftPercentage = this.left / this.moveRange
    },
    scroll: function (deltaX) {
      const minLeft = -this.moveRange
      let newLeft = this.left + deltaX
      if (newLeft > maxLeft) {
        newLeft = maxLeft
      }
      if (newLeft < minLeft) {
        newLeft = minLeft
      }
      this.left = newLeft
      this.leftPercentage = this.left / this.moveRange
      this.$emit('scrollLeft', this.left)
      this.scrollElementByLeft()
    },
    scrollByWheel: function (event) {
      if (this.show) {
        const deltaX = (event.deltaY > 0) ? (-this.mouseMoveRange) : this.mouseMoveRange
        this.scroll(deltaX)
      }
    },
    scrollElementByLeft: function () {
      let header = this.getTableHeader()
      let rightHeader = header.children[1]
      rightHeader.style.left = (this.left * this.moveStep) + 'px'
      let rightDataRows = this.table.querySelectorAll('.data-row.right')
      rightDataRows.forEach((rightDataRow) => {
        rightDataRow.style.left = (this.left * this.moveStep) + 'px'
      })
    }
  },
  computed: {
    scrollLeft: function () {
      return this.left * -1
    },
    scrollContetnLeft: function () {
      return this.left * this.moveStep
    },
    mouseMoveRange () {
      return this.$store.state.component.tableMouseMoveRange
    }
  },
  watch: {
    show: function (value) {
      this.$emit('columnScrollbarShow', value)
    }
  }
}
</script>
<style lang="scss">
.qweb-column-scrollbar {
  background-color: #eaeaea;
  float: right;
  display: flex;
  z-index: 1;
  &.qweb-scrolling {
    user-select: none; //IE is not working on scrolling. Maybe we can use a overlay to avoid that.
  }
  >.qweb-scroll-area {
    flex: 1;
    height: 12px;
    background-color: #eaeaea;
    position: relative;
    >.qweb-scroll {
      height: 12px;
      background-color: #d1d1d1;
      border: 1px #c0c0c0 solid;
      position: absolute;
      cursor: default;
      &:hover,
      &:active {
        background-color: #9b9b9b;
        border: 1px #898989 solid;
      }
    }
  }
  >.left {
    width: 12px;
    height: 12px;
    transform: rotate(270deg);
    background-image: url("../../assets/scrollbar/w_up_normal.png");
    cursor: pointer;
    &:hover {
      background-image: url("../../assets/scrollbar/w_up_over.png");
    }
    &:active {
      background-image: url("../../assets/scrollbar/w_up_press.png");
    }
    &:disabled {
      background-image: url("../../assets/scrollbar/w_up_disable.png");
    }
  }
  >.right {
    width: 12px;
    height: 12px;
    transform: rotate(270deg);
    background-image: url("../../assets/scrollbar/w_down_normal.png");
    cursor: pointer;
    &:hover {
      background-image: url("../../assets/scrollbar/w_down_over.png");
    }
    &:active {
      background-image: url("../../assets/scrollbar/w_down_press.png");
    }
    &:disabled {
      background-image: url("../../assets/scrollbar/w_down_disable.png");
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/table/ColumnScrollbar.vue